import { MarginReportAccount } from '../types/marginReports';

export const MARGIN_REPORT_KEYS = {
  AccountName: 'Account Name',
  ProjectName: 'Project Name',
  MemberName: 'Member Name',
  Stream: 'Stream',
  Seniority: 'Seniority',
  GrossMargin: 'Gorss margin %',
  NetMargin: 'Net margin %',
  PastRevenue: 'Revenue',
  ProjectedRevenue: 'Projected Revenue',
  BillRate: 'Bill Rate',
  PayRate: 'Pay Rate',
  CompensationRangeMin: 'Compensation Range Min',
  CompensationRangeMax: 'Compensation Range Max',
  CompensationRangeApproved: 'Compensation Range Approved',
  Ratecard: 'Ratecard',
  Location: 'Location',
  AvgMonthlyHours: 'Average working hours per location',
};

export const marginReportFieldsOrder = [
  MARGIN_REPORT_KEYS.AccountName,
  MARGIN_REPORT_KEYS.ProjectName,
  MARGIN_REPORT_KEYS.MemberName,
  MARGIN_REPORT_KEYS.Stream,
  MARGIN_REPORT_KEYS.Seniority,
  MARGIN_REPORT_KEYS.GrossMargin,
  MARGIN_REPORT_KEYS.NetMargin,
  MARGIN_REPORT_KEYS.PastRevenue,
  MARGIN_REPORT_KEYS.ProjectedRevenue,
  MARGIN_REPORT_KEYS.BillRate,
  MARGIN_REPORT_KEYS.PayRate,
  MARGIN_REPORT_KEYS.CompensationRangeMin,
  MARGIN_REPORT_KEYS.CompensationRangeMax,
  MARGIN_REPORT_KEYS.CompensationRangeApproved,
  MARGIN_REPORT_KEYS.Ratecard,
  MARGIN_REPORT_KEYS.Location,
  MARGIN_REPORT_KEYS.AvgMonthlyHours,
];

export const HEADCOUNT_CHANGE_REPORT_KEYS = {
  ProjectName: 'Project Name',
  CountChange: 'Projected Headcount',
  Date: 'Date',
  BlendedRate: 'Blended Rate',
  BlendedPayRate: 'Blended Pay Rate',
};

export const headcountChangesFieldOrder = [
  HEADCOUNT_CHANGE_REPORT_KEYS.ProjectName,
  HEADCOUNT_CHANGE_REPORT_KEYS.CountChange,
  HEADCOUNT_CHANGE_REPORT_KEYS.Date,
  HEADCOUNT_CHANGE_REPORT_KEYS.BlendedRate,
  HEADCOUNT_CHANGE_REPORT_KEYS.BlendedPayRate,
];

export const ALL_ACCOUNTS_ITEM: MarginReportAccount = {
  id: '',
  name: 'All accounts',
};
